module.exports = __webpack_public_path__ + "img/arrow-up-right.05cf2f0b.svg";